/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Row,
  Button,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import { useToasts } from "react-toast-notifications";
import ReactPaginate from "react-paginate";

import FullPageLoader from "components/FullPageLoader/fullpageloader";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import { postMethod } from "../../services/httpServices";
import { getAmt } from "services/util";
import AddStocks from "./add-stocks";
import { btnCss } from "appConfig";
import { iconCss } from "appConfig";

const StockInList = () => {
  const [loading, setLoading] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [totalRec, setTotalRec] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [open, setOpen] = useState(false);

  const timerRef = useRef();

  const { addToast } = useToasts();

  useEffect(() => {
    fetchStockInList();
  }, [currentPage, sortConfig]);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      fetchStockInList();
    }, 500);

    return () => clearTimeout(timerRef.current);
  }, [searchText]);

  const handleSearchChange = (value) => {
    setSearchText(value);
  };

  const notifyFailed = (text = "Error fetching data") => {
    addToast(text, { appearance: "error", autoDismiss: true });
  };

  const toggleSort = (key) => {
    setSortConfig((prev) => {
      let direction = prev.direction === "asc" ? "desc" : "asc";
      if (prev.key !== key) direction = "asc";
      return { key, direction };
    });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <i className="fas fa-sort ml-1" />;
    return sortConfig.direction === "asc" ? (
      <i className="fas fa-sort-up ml-1" />
    ) : (
      <i className="fas fa-sort-down ml-1" />
    );
  };

  const fetchStockInList = async () => {
    setLoading(true);
    try {
      const res = await postMethod(
        "/api/Inventory/GetSearchAllStocksIn",
        {
          searchText,
          isDescending: sortConfig.direction === "desc",
          sortingOn: sortConfig.key,
          perPage: 10,
          pageNumber: currentPage + 1,
        },
        "post"
      );
      setLoading(false);
      if (res?.data?.responseCode === "200") {
        const list = res.data.result.list || [];
        setStockList(list);
        setTotalRec(res.data.result.totalRecords);
        setPageCount(res.data.result.totalPages);
      } else {
        notifyFailed(res?.data?.responseMessage);
      }
    } catch (error) {
      setLoading(false);
      notifyFailed("Something went wrong!");
    }
  };

  const closeModal = () => {
    setOpen(false);
    fetchStockInList();
  };

  return (
    <>
      <Modal isOpen={open} style={{ width: "90vw", maxWidth: "90vw" }}>
        <ModalBody style={{ padding: 0, width: "100%" }}>
          <AddStocks closeModal={closeModal} />
        </ModalBody>
      </Modal>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex p-0 pr-4 justify-content-between align-items-center">
              <Form
                className="form-inline mr-3 d-md-flex ml-lg-auto"
                onSubmit={(e) => e.preventDefault()}
              >
                <FormGroup className="mb-0 navbar-search ">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      className="search-cls"
                      placeholder="Search"
                      type="text"
                      value={searchText}
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </Form>
              &nbsp;&nbsp;
              <Button
                className="my-4"
                color="primary"
                onClick={() => setOpen(true)}
              >
                Add Stock
              </Button>
              <Button
                color="primary"
                onClick={() => fetchStockInList()}
                size="sm"
                style={btnCss}
                data-toggle="tooltip"
                title="Refresh"
              >
                <i className="fas fa-redo fa-lg" style={iconCss} />
              </Button>
            </CardHeader>

            <div>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    {[
                      ["productUniqueCode", "Product Code"],
                      ["productName", "Product Name"],
                      ["categoryName", "Category"],
                      ["subCategoryName", "Subcategory"],
                      ["quantity", "Quantity"],
                      ["source", "Source"],
                      ["referenceNote", "Reference Note"],
                      ["merchantName", "Merchant"],
                      ["createdAt", "Created Date"],
                      ["createdBy", "Created By"],
                    ].map(([key, label]) => (
                      <th
                        key={key}
                        onClick={() => toggleSort?.(key)}
                        style={{ cursor: toggleSort ? "pointer" : "default" }}
                      >
                        {label} {getSortIcon?.(key)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {stockList.map((item, i) => (
                    <tr key={item.id || i}>
                      <td>{item.productUniqueCode}</td>
                      <td>{item.productName}</td>
                      <td>{item.categoryName}</td>
                      <td>{item.subCategoryName}</td>
                      <td>{getAmt(item.quantity)}</td>
                      <td>{item.source}</td>
                      <td>{item.referenceNote}</td>
                      <td>{item.merchantName}</td>
                      <td>{item.createdAt?.split("T")[0]}</td>
                      <td>{item.createdBy}</td>
                    </tr>
                  ))}
                  {stockList.length === 0 && (
                    <tr>
                      <td colSpan="10" className="text-center text-muted">
                        No stock records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {loading && <FullPageLoader label="Fetching..." />}
            {!loading && stockList.length === 0 && <NoRecordFound />}

            <CardFooter className="py-4">
              <Row>
                <Col lg="6">
                  <small>
                    <strong>Total Records : {totalRec}</strong>
                  </small>
                </Col>
                <Col lg="6">
                  <nav aria-label="...">
                    <div className="float-right">
                      <ReactPaginate
                        previousLabel="prev"
                        nextLabel="next"
                        breakLabel="..."
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={({ selected }) =>
                          setCurrentPage(selected)
                        }
                        containerClassName="paginationV2"
                        activeClassName="active"
                        forcePage={currentPage}
                      />
                    </div>
                  </nav>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </div>
      </Row>
    </>
  );
};

export default StockInList;
